import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export const cn = (...a) => twMerge(clsx(a));
